import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import jaCommon from "../locales/ja/common.json";
import enCommon from "../locales/en/common.json";
import zhCommon from "../locales/zh/common.json";

export const SUPPORTED_LANGUAGES = [
  { code: "ja", name: "日本語", flag: "🇯🇵" },
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "zh", name: "中文", flag: "🇨🇳" },
] as const;

export type SupportedLanguageCode = (typeof SUPPORTED_LANGUAGES)[number]["code"];

const getPathLanguage = (): string | null => {
  if (typeof window === "undefined") return null;
  const segments = window.location.pathname.split("/").filter(Boolean);
  if (segments.length > 0) {
    if (segments[0] === "jp") return "ja";
    if (segments[0] === "us") return "en";
    if (segments[0] === "cn") return "zh";
  }
  return null;
};

const customPathDetector = {
  name: "customPathDetector",
  lookup() {
    return getPathLanguage() || undefined;
  },
  cacheUserLanguage() {},
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(customPathDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ja: { common: jaCommon },
      en: { common: enCommon },
      zh: { common: zhCommon },
    },
    fallbackLng: "ja",
    supportedLngs: ["ja", "en", "zh"],
    nonExplicitSupportedLngs: true,
    ns: ["common"],
    defaultNS: "common",
    detection: {
      order: ["customPathDetector", "querystring", "localStorage", "navigator", "htmlTag"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

const updateDocumentFontLanguage = (lng: string) => {
  const code = (lng || "ja").split("-")[0];
  if (typeof document !== "undefined") {
    document.documentElement.lang = code;
    document.body.setAttribute("data-lang", code);
  }
};

i18n.on("languageChanged", (lng) => {
  updateDocumentFontLanguage(lng);
});

// Set initial attribute on load
updateDocumentFontLanguage(i18n.language || "ja");

export default i18n;
